// Components
import About from '../../../main/About'
import Education from '../../../main/Education'
import Experience from '../../../main/Experience'
import Languages from '../../../main/Languages'
import Skills from '../../../main/Skills'

const renderComponent = ({
  id,
  userProfile,
  editMode,
  toggleModal,
  openModal,
  removeComponent,
}) => {
  return (
    <div draggable={editMode ? true : false} style={{ height: '100%' }}>
      {(() => {
        if (userProfile) {
          switch (id) {
            case '1':
              return (
                <About
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={true}
                  editMode={editMode}
                  removeComponent={removeComponent}
                />
              )
            case '2':
              return (
                <Experience
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={true}
                  editMode={editMode}
                  removeComponent={removeComponent}
                />
              )
            case '3':
              return (
                <Education
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={true}
                  editMode={editMode}
                  removeComponent={removeComponent}
                />
              )
            case '4':
              return (
                <Skills
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={true}
                  editMode={editMode}
                  removeComponent={removeComponent}
                />
              )
            case '5':
              return (
                <Languages
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={true}
                  editMode={editMode}
                  removeComponent={removeComponent}
                />
              )
            default:
              return null
          }
        }
      })()}
    </div>
  )
}

export default renderComponent
